module.exports = __webpack_public_path__ + "assets/478777ca1c44692612f70f2b04626e91.mp3";